import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { SliderField } from "@circle-react-shared/BuilderUI/Editor/fields/SliderField";
import { useCustomColors } from "@circle-react-shared/BuilderUI/ThemeConfiguration/hooks/useCustomColors";
import { Form } from "@circle-react-uikit/Form";
import { generateFormItemName } from "./Styles";

export const Borders = () => {
  const { flattenedCssVariables } = useCustomColors();
  const labelClassName = "!font-normal text-xs";
  return (
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.border")}
      defaultOpen
    >
      <div className="space-y-4 px-6 py-5">
        <Form.Item
          name={generateFormItemName("borderColor")}
          label={t("builder_ui.prop_type.styles.border_color")}
          hideDescription
          hideBorder
          className="!flex !w-full !items-center !justify-between !p-0"
          labelClassName={labelClassName}
        >
          <Form.ColorPickerV2
            name={generateFormItemName("borderColor")}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable
            shouldShowAlpha={false}
          />
        </Form.Item>

        <SliderField
          name={generateFormItemName("borderWidth")}
          label={t("builder_ui.prop_type.styles.border_width")}
          units={["px"]}
          step={1}
          min={0}
          max={100}
        />
      </div>
    </EditorCollapsable>
  );
};
